import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { AuthState } from "../store/app.states";
import { Store } from "@ngrx/store";
import { Logout } from "../store/actions/authentication.actions";
import { Constant } from "../constant/constant";
import { ToastService } from "../../../../@core/services/toast.service";
@Injectable({
  providedIn: "root",
})
export class LoaderInterceptorService implements HttpInterceptor {
  constructor(
    private router: Router,
    private store: Store<AuthState>,
    private constant: Constant,
    private toast: ToastService
  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
          }
        },
        (err: any) => {
          this.handleAuthError(err);
        }
      )
    );
  }
  private handleAuthError(err: HttpErrorResponse) {
    const { error } = err;
    if (
      err.status === this.constant.HTTP_CODES.UNAUTHORIZED &&
      error?.message === "Forbidden"
    ) {
      this.router.navigate(["/login"]);
    } else if (err.status === this.constant.HTTP_CODES.UNAUTHORIZED) {
      this.toast.error(this.constant.GENERIC_ERROR_MSG.UNAUTHORIZED);
    } else if (err.status === this.constant.HTTP_CODES.FORBIDDEN) {
      this.toast.error(this.constant.GENERIC_ERROR_MSG.FORBIDDEN);
    }
  }
}
